type Props = {
  id: string;
  label: string;
  helper?: string;
  options: string[];
  value: string;
  onChange: (v: string) => void;
  required?: boolean;
  error?: string;
};

export function RadioGroup({ id, label, helper, options, value, onChange, required, error }: Props) {
  return (
    <fieldset style={{ border: 0, padding: 0, margin: 0 }}>
      <legend className="field-label">
        {label}
        {required && (
          <span className="req" aria-hidden="true">
            *
          </span>
        )}
      </legend>
      {helper && <div className="field-help">{helper}</div>}
      <div className="radio-stack" role="radiogroup" aria-required={required} aria-invalid={Boolean(error)}>
        {options.map((opt) => {
          const optionId = `${id}-${opt.replace(/\s+/g, "-").toLowerCase()}`;
          const selected = value === opt;
          return (
            <label key={opt} htmlFor={optionId} className="radio-card" data-selected={selected}>
              <input
                id={optionId}
                type="radio"
                name={id}
                value={opt}
                checked={selected}
                onChange={() => onChange(opt)}
              />
              <span>{opt}</span>
            </label>
          );
        })}
      </div>
      {error && (
        <div className="field-error" role="alert">
          {error}
        </div>
      )}
    </fieldset>
  );
}
